import { Mapper } from "../../../../base/utils/mapper";
import { MotilityResponseModel } from "../../../../domain/models/consult/motility-response.model";
import { MotilityResponseEntity } from "../entities/motility-response.entity";

export class MotilityImplementationRepositoryMapper extends Mapper<MotilityResponseEntity, MotilityResponseModel> {
    mapFrom(param: MotilityResponseEntity): MotilityResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: MotilityResponseModel): MotilityResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}